package floris.graphics.models.dto.responses

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ErrorResponse(
    val error: String,
    @SerialName("error_description")
    val errorDescription: String,
    val status: Int
//    val errors: ArrayList<String>? = null
)
